import { LicenseManager as AGGridLicenseManager } from "ag-grid-enterprise";

export const setAGGridLicense = () => AGGridLicenseManager.setLicenseKey(process.env.REACT_APP_AGGRID_LICENSE_KEY as string);